import { Component, inject, OnInit } from '@angular/core';
import { DynamicLayoutComponent, AuthService, EnvironmentService } from '@abp/ng.core';
import { LoaderBarComponent } from '@abp/ng.theme.shared';
import { OAuthService } from 'angular-oauth2-oidc';
import { connectNotificationHub, disconnectNotificationHub } from './core/signals/notification.signal';

@Component({
  selector: 'app-root',
  template: `
    <abp-loader-bar />
    <abp-dynamic-layout />
  `,
  imports: [LoaderBarComponent, DynamicLayoutComponent],
})
export class AppComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly oauth = inject(OAuthService);
  private readonly env = inject(EnvironmentService);

  ngOnInit(): void {
    const tokenFactory = () => this.auth.getAccessToken() || this.oauth.getAccessToken();
    const apiUrl = this.env.getApiUrl('default');

    if (this.auth.isAuthenticated || this.oauth.hasValidAccessToken()) {
      connectNotificationHub(tokenFactory, apiUrl);
    }

    this.oauth.events.subscribe((e) => {
      if (e.type === 'token_received' || e.type === 'token_refreshed') {
        connectNotificationHub(tokenFactory, apiUrl);
      } else if (e.type === 'logout') {
        disconnectNotificationHub();
      }
    });
  }
}
